/**
 * @module @shared/api/query-client
 * Geteilter TanStack-Query-Client. `networkMode: 'always'`, damit Queries auch
 * in Automation-/Headless-Browsern laufen, die `navigator` fälschlich offline
 * melden (sonst bleiben sie in `fetchStatus: 'paused'` hängen).
 */
import { QueryClient } from '@tanstack/react-query';

/** Singleton-QueryClient der Login-App. */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      gcTime: 1000 * 60 * 10,
      retry: 1,
      refetchOnWindowFocus: false,
      networkMode: 'always',
    },
    mutations: {
      networkMode: 'always',
    },
  },
});
